var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},_vm._l((_vm.processes),function(summary){return _c('b-row',{key:summary.process},[_c('b-col',[_c('process-group',{attrs:{"summary":summary,"timeRangeQuery":_vm.timeRangeQuery}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }